import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { measurementsActions } from '../../../../../store/slices/measurementsSlice/measurementsSlice';
import AdditionallyClass from '../../../helpers/AdditionallyClass';

export const useAdditionally = () => {
    const dispatch = useDispatch();
    const { ids: additionallyList } = useSelector(
        (state) => state.measurementsReducer.additionallyList
    );

    const addCard = useCallback(() => {
        const newCard = new AdditionallyClass();
        dispatch(measurementsActions.addAdditionally(newCard.toPlainObject()));
    }, []);

    return { additionallyList, addCard };
};
